// extracted by mini-css-extract-plugin
export default {"appNotification":"DiscountReaderStyles_appNotification__Rp9-h"};